module.exports = __webpack_public_path__ + "static/media/PasPhoto.88bb7a92.jpg";